import { ISupportHistoryResponse } from '~/src/repositories/MemberRepository/model/SupportHistory'

export interface IHistoryData {
  pagination: {
    currentPage: number
    limitValue: number
    totalCount: number
    totalPages: number
  }
  histories: {
    date: string | undefined
    manager: string | undefined
    contents: string | undefined
    name: string | undefined
  }[]
}
export const convertData = (data: ISupportHistoryResponse): IHistoryData => {
  return {
    histories: data?.histories?.map((history) => ({
      date: history?.date,
      name: history?.user.name,
      manager: history?.admin.name,
      contents: history?.message,
    })),
    pagination: data.pagination,
  }
}
